import script from "./CommodityExplainListResult.vue?vue&type=script&setup=true&lang=js"
export * from "./CommodityExplainListResult.vue?vue&type=script&setup=true&lang=js"

import "./CommodityExplainListResult.vue?vue&type=style&index=0&id=1c674cde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c674cde"]])

export default __exports__